import * as Scrivito from "scrivito";

const OutroPageWidget = Scrivito.provideWidgetClass("OutroPageWidget", {
  attributes: {
    headline: "string",
    hint: "string",
  },
  onlyInside: ["FormWidget"],
});
export default OutroPageWidget;
